export const enum StpTradeDirection {
  BUY = 'BUY',
  SELL = 'SELL'
}
